module.exports = __webpack_public_path__ + "static/media/RW.2a59b860.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/RW.svg
// module id = 2251
// module chunks = 7